import logIcon from "../../../assets/images/log.svg";
import patientsIcon from "../../../assets/images/patients.svg";
import logsColoredIcon from "../../../assets/images/logs-colored.svg";
import patientsColoredIcon from "../../../assets/images/patients-colored.svg";
import { useLocation, useNavigate } from "react-router-dom";
import {
  IoArrowBack,
  IoCompass,
  IoCompassOutline,
  IoArrowBackCircleOutline,
} from "react-icons/io5";
import { getLocalStorage } from "../../../utils/localStorage";
import { FROM_TATAV_PRACTICE } from "../../../utils/constants";
import { navigateToTatvaPractice } from "../../../utils/helper";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleNavigation = (path: string) => {
    if (location.pathname === path) {
      return;
    }

    navigate(path);
  };
  const handleHomeNavigation = () => {
    const fromPractice = getLocalStorage(FROM_TATAV_PRACTICE);
    if (fromPractice && fromPractice === "true") {
      navigateToTatvaPractice();
    } else {
      handleNavigation("/");
    }
  };
  return (
    <div className="flex justify-between px-6 py-2 h-[64px] w-full text-xs max-w-[1280px] fixed bottom-0 z-10 bg-white shadow-2xl">
      <div
        className={`flex flex-col justify-center items-center pr-4 border-r border-black border-opacity-10 cursor-pointer ${
          isActive("/") ? "text-indigo-600" : "text-zinc-700"
        }`}
        role="button"
        aria-label="Go to Home"
        onClick={handleHomeNavigation}
      >
        {isActive("/") ? (
          <IoArrowBack className="w-6 h-6" />
        ) : (
          <IoArrowBackCircleOutline className="w-6 h-6" />
        )}
        <div className={`mt-1 ${isActive("/") ? "font-semibold" : ""}`}>
          Home
        </div>
      </div>

      <div
        className={`flex flex-col justify-center items-center cursor-pointer ${
          isActive("/remote-care") ? "text-indigo-600" : "text-zinc-700"
        }`}
        role="button"
        aria-label="Go to Discover"
        onClick={() => handleNavigation("/remote-care")}
      >
        {isActive("/remote-care") ? (
          <IoCompass className="w-6 h-6" />
        ) : (
          <IoCompassOutline className="w-6 h-6" />
        )}
        <div
          className={`mt-1 ${isActive("/remote-care") ? "font-semibold" : ""}`}
        >
          Explore
        </div>
      </div>

      <div
        className={`flex flex-col justify-center items-center cursor-pointer ${
          isActive("/patients") ? "text-indigo-600" : "text-zinc-700"
        }`}
        role="button"
        aria-label="Go to Library"
        onClick={() => handleNavigation("/patients")}
      >
        <img
          loading="lazy"
          src={isActive("/patients") ? patientsColoredIcon : patientsIcon}
          alt="Patients"
          className="object-contain w-6 aspect-square"
        />
        <div className={`mt-1 ${isActive("/patients") ? "font-semibold" : ""}`}>
          Patients
        </div>
      </div>

      <div
        className={`flex flex-col justify-center items-center cursor-pointer ${
          isActive("/patient-logs") ? "text-indigo-600" : "text-zinc-700"
        }`}
        role="button"
        aria-label="Go to Library"
        onClick={() => handleNavigation("/patient-logs")}
      >
        <img
          loading="lazy"
          src={isActive("/patient-logs") ? logsColoredIcon : logIcon}
          alt="Log"
          className="object-contain w-6 aspect-square"
        />
        <div
          className={`mt-1 ${isActive("/patient-logs") ? "font-semibold" : ""}`}
        >
          Vitals
        </div>
      </div>
    </div>
  );
}
